import rpcClient from './rpcClient';
import { signUrlRpc, signUrlForFormRpc } from '../../__generated__/chirp/com/hubspot/url/signer/rpc/UrlSignerRpc';
export default function signUrl(url, httpMethod, payloadData) {
  return rpcClient.call(signUrlRpc, {
    request: {
      unsignedUrl: url,
      httpMethod,
      entity: payloadData
    }
  });
}
export function signUrlForForm(url, httpMethod, formData) {
  return rpcClient.call(signUrlForFormRpc, {
    request: {
      unsignedUrl: url,
      httpMethod,
      formData
    }
  });
}